import { connect } from 'react-redux';
import EligibilityAgentButton from './EligibilityAgentButton';
import * as eligibilityActions from '../../../redux/actions/eligibility.actions';
import { validateMultiEligibility } from '../../../parsers/eligibility.parser';
import { trackEvent } from '../../../services/datadog';
import { createWandAttemptId } from '../../../utils/wandAttempt';

const STATUS_TEXT_MAP = {
  verifying: 'Eligibility Agent is Verifying...',
  applying_changes: 'Eligibility Agent is Applying Changes...',
  completed: 'Eligibility Agent Completed',
  failed: 'Eligibility Agent Failed',
};

const PROCESSING_STATES = ['verifying', 'applying_changes'];

const mapStateToProps = state => {
  const requestId = state.requests.request?.id;
  const coverages = state.infobox.coverages || {};
  const validationReasons = validateMultiEligibility(state);
  const agentStatus = state.eligibility.agentStatus;

  return {
    disabled: validationReasons.length > 0,
    tooltipTitle: validationReasons.join(' '),
    isHidden: state.eligibility.agentView.isOpen || state.eligibility.isAgentProcessing,
    requestId,
    coverageCount: Object.keys(coverages).length,
    agentStatus,
  };
};

const mapDispatchToProps = {
  checkMultiEligibility: eligibilityActions.checkMultiEligibility,
};

export const mergeProps = (stateProps, dispatchProps) => {
  const { agentStatus, requestId, ...rest } = stateProps;
  const statusState = agentStatus?.state;
  const isProcessing = PROCESSING_STATES.includes(statusState);
  const hasAppliedChanges =
    statusState === 'completed' && agentStatus.changesApplied && !agentStatus.isCurrentUserUpdate;

  const onClick = isProcessing
    ? () => {} // no-op, when disabled
    : () => {
        // when idle, failed, completed
        const wandAttemptId = createWandAttemptId();
        try {
          trackEvent('eligibility_agent.wand_clicked', {
            trigger_source: 'wand',
            request_id: stateProps.requestId,
            coverage_count: stateProps.coverageCount,
            wand_attempt_id: wandAttemptId,
          });
        } catch (e) {
          console.error(e);
        }
        dispatchProps.checkMultiEligibility({ wandAttemptId });
      };

  const lookupStatusText = STATUS_TEXT_MAP[statusState] || null;
  const statusText =
    lookupStatusText && hasAppliedChanges ? `${lookupStatusText}. Some changes were applied.` : lookupStatusText;

  return {
    ...rest,
    disabled: stateProps.disabled,
    tooltipTitle: stateProps.tooltipTitle,
    isHidden: stateProps.isHidden,
    statusText,
    onClick,
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(EligibilityAgentButton);
